import type { FC } from 'react';
import classNames from 'classnames';

import { SPALink } from '@hh.ru/redux-spa-middleware';

import { useIsHeadHunterPlatform, useIsZarplataPlatform } from 'src/hooks/usePlatform';
import { useIsRabotaBy } from 'src/hooks/useSites';

import styles from './styles.less';

const HeaderLogo: FC = () => {
    const isHH = useIsHeadHunterPlatform();
    const isRabotaBy = useIsRabotaBy();
    const isZarplata = useIsZarplataPlatform();

    return (
        <SPALink to="/" className={styles.link}>
            <div
                className={classNames(styles.logo, {
                    [styles.hhLogo]: isHH,
                    [styles.rabotaLogo]: isRabotaBy,
                    [styles.zarplataLogo]: isZarplata,
                })}
            />
        </SPALink>
    );
};

export default HeaderLogo;
